import React, { Component } from 'react';
import ReactIScroll from 'react-iscroll';
var iScroll = require('iscroll/build/iscroll-probe');
import { connect } from 'react-redux';
import _ from 'lodash';
import { shallowEqual } from '../../../utils/shared.js';
// import { donorsIncluded } from '../../../utils/donorHelpers';
import { getFileType, videoType } from '../../../utils/fileHelpers';
import LinkListChicago from './LinkListChicago';
import CircleImageInfoBlock from '../../General/CircleImageInfoBlock';
import InfoBlock from '../../General/InfoBlock';
import StoryChicagoModal from './StoryChicagoModal'
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup'
import shared from '../../../utils/shared.js'
import StoryAnnouncement from './StoryAnnouncement';

const config = {
	showTitle: true,
	showName: true,
	showSubheader: false,
	columns: 2,
	cycle_all_groups: true
}
const QuillDeltaToHtmlConverter = require('quill-delta-to-html');
class StoriesFoldersChicago extends Component {
	constructor(props) {
		super(props);
		
		this.state = {
			donorsGrouped: [],
			selectedLinkIndex: 0,
			selectedStoryIndex: 0,
			showStory: false,
			story: {
				contextualheader: null,
				headline: null,
				subtitle: null,
				body: null,
				quote: null,
				mainimage: null,
				id: null,
				slickAssets: null
			},
			initializedRefs: false,
			stories: []
		}
		this.refDict = null;
		this.scrollRef = {};

		// this._fontClass = null;
		// if (_.has(this.props.module.contents, 'custom_fields.override_font_family')) {
		// 	if (this.props.module.contents.custom_fields.override_font_family.val) {
		// 		this._fontClass = this.props.module.contents.custom_fields.font_family.val.value;
		// 	}
		// }

		this._fontClass=_.get(this.props, 'module.contents.custom_fields.font_family.val.value', null);

		let titleFont = this._fontClass ? null : "aleo-bolditalic";
		this._titleStyle = {
			fontFamily: titleFont,
			fontSize: this.props.screen.r16_9.p10,
			marginLeft: this.props.screen.r16_9.p10 * 0.7,
		}
		this._titleHorizontalRule = {
			width: '89.5%',
			height: this.props.screen.r16_9.p10 * 0.15,
			backgroundColor: '#223954',
			display: 'inline-block',
			position: 'absolute',
			top: this.props.screen.r16_9.p10 * 1.25,
			left: 0,
			marginLeft: this.props.screen.r16_9.p10 * 0.7,
		}

		let subheaderFont = this._fontClass ? null : "ostrich-medium";
		this._subheaderStyle = {
			fontFamily: subheaderFont,
			fontSize: this.props.screen.r16_9.p10 * 0.5,
			marginLeft: this.props.screen.r16_9.p10 * 0.7,
		}
		this._titleSpacer = {
			width: '100%',
			height: this.props.screen.r16_9.p10 * 0.3,
			display: 'inline-block'
		}

		this._avatarList = {
			width: this.props.screen.r16_9.width - this.props.screen.r16_9.p10 * 3,
			height: this.props.screen.r16_9.height,
		}

		this._donorGroupIndex = 0;
		this._selectDonorId = 0;
		this.donorRefs = [];
		this._refCounter = 0;
		this._donorRowHeight = 0;

	}

	componentWillMount() {
		// checkData(this.props.module);
	}

	componentWillUnmount() {
		for (let a = 0; a < this.donorRefs.length; a++) {
			//let count = 0;
			if (this.donorRefs[a].el) {
				this.donorRefs[a].el.removeEventListener("tap", () => this.handleTap(this.donorRefs[a].data));
			}
		}
	}

	componentDidMount() {
		this.prepareStories();
	}

	shouldComponentUpdate(prevProps, prevState) {
		if (shallowEqual(this.state, prevState)) {
			return false;
		}
		return true;
	}

	handleTap = (data, i) => {
		console.log("Clicked here", data);
		this.handleDonorClick(data.innerrow, i);
	}

	prepareStories = () => {
		let folder = this.props.content.story_categories[Number(this.props.folder)];
    let stories = this.props.content.folder_modules
    .filter(fm => fm.folder === Number(folder.id) && fm.model === 'story')
		.map(fm => this.props.content.stories.find(story => story.id === fm.module_id))
		.filter(fm => fm !== undefined);
		
		this.setState({
      stories: stories,
			// donorsGrouped: donorsIncluded(this.props.donors.donorCategories, this.props.module.contents.include_categories)
		});
	}

	switchCategory = (ref) => {
		this.setState({
			selectedLinkIndex: ref
		})
		this.scrollRef[0].withIScroll((iScroll) => {
			iScroll.disable();
			iScroll.enable();
			iScroll.scrollToElement(this.refDict[ref], 500, 0, 0, false) //-this.props.screen.r16_9.p10
		})
	}

	initializeDonorRefs = () => {
		if (this.state.initializedRefs === false) {
			if (this.donorRefs.length > 0) {
				this._donorRowHeight = this.donorRefs[0].el.clientHeight;
				for (let a = 0; a < this.donorRefs.length; a++) {
					this.donorRefs[a].el.addEventListener("tap", () => this.handleTap(this.donorRefs[a].data, a));
				}
				this.setState({
					initializedRefs: true
				})
			}
		}
	}

	padLastCategory = (category) => {
		//logic to check numbe rof names and add padding if < 8 and add the right amount for instance 6 names needs less padding then 2.
		//multiple of this.props.screen.r16_9.p10 for height of a single cell.

		let padding = 0;
		if (category.donors.length < 7) {
			padding = this._donorRowHeight;
		}

		if (category.donors.length < 5) {
			padding = this._donorRowHeight * 2
		}

		if (category.donors.length < 3) {
			padding = this._donorRowHeight * 3;
		}

		return (
			<div style={{ width: '100%', height: padding + 'px' }}>
			</div>
		)
	}
  
  renderStories = () => {
		let storiesLength = this.state.stories ? this.state.stories.length : 0;
		let fData = {
			unit: (this._avatarList.width * 0.12) / config.columns,
			counter: 0,
			h_spacing: this._avatarList.width / config.columns - this._avatarList.width * .025,
			v_spacing: this._avatarList.height / storiesLength / config.columns
		}
		let rows = [];
		let row = [];

		const sortedStories = _.orderBy(this.state.stories, ['sorting_name', 'asc'])
		if (sortedStories && sortedStories.length > 0) {
			for (let i = 0; i < sortedStories.length; i++) {
				row.push(sortedStories[i]);
				if (row.length === 2 || (i === sortedStories.length - 1)) {
					rows.push(row);
					row = [];
				}
			}
		}
		let folder = this.props.content.story_categories[Number(this.props.folder)];
		if (sortedStories && sortedStories.length > 0) {
			return (
				<div className={this._fontClass} ref={el => this.refDict = el}>
					<span style={{ display: "inline-block", height: this._titleHorizontalRule.top + this._titleHorizontalRule.height }}>
						<span style={this._titleStyle}>{folder.name ? folder.name : <span>Donors</span>}</span>
						<span style={this._titleHorizontalRule} />
					</span>
					{
						rows.map((row, i) => {
							return (
								<div key={i}>
									{
										row.map((story, j) => {
											let desc = "";
											let iref = null;
											if (_.has(story, 'contents.texts[0].text')) {
												desc = story.contents.texts[0].text
											}
											if (_.has(story, 'contents.images[0]')) {
												iref = story.contents.images[0];
											}
											return(
												<div className={this._fontClass} ref={el => this.donorRefs[this._refCounter++] = { el: el, data: { innerrow: story, groupIndex: i } }} style={{ marginTop: this.props.screen.r16_9.p10 * .3, display: 'inline-block', width: fData.h_spacing }} key={j}>
													<span style={{ width: this.props.screen.r16_9.p10 * 0.7, display: "inline-block" }} />
													<InfoBlock unit={fData.unit} header={story.name} text={desc} headerColor={'#223954'} fontClass={this._fontClass} />
													<CircleImageInfoBlock mode={this.props.screen.mode} webkey={this.props.screen.webkey} image={iref} size={fData.unit * 2} screen={this.props.screen} name={story.name} />
												</div>
											)
										})
									}
								</div>
							);
						})
					}
				</div>
			);
		}
  }

	closeStory = () => {
		this.props.toggleShowClock(true);
		this.setState({
			showStory: false,
			story: {
				id: -1
			}
		})
	}

	handleDonorClick = (data, storyIndex) => {
		let slickAssets = [];
		let type = _.get(data, 'contents.custom_fields.story_type.val.value', null);

		if (type === "baby_announcement") {
			const sortedStories = _.orderBy(this.state.stories, ['sorting_name', 'asc']);
			let story = sortedStories[storyIndex];
			let customFields = _.get(story, 'contents.custom_fields', {});
			let slideshows = [];
			let otherModules = [];

			for (let field in customFields) {
				if (customFields[field].type === "module" && customFields[field].module === "slideshow") {
					let id = _.get(customFields[field], 'val.value', null);
					if (id) {
						slideshows = _.filter(this.props.content.dm_active, { id: id, display_module_type: "Slideshow" });
					}
				}
			}

			otherModules = otherModules.concat(slideshows);
			this.props.toggleShowClock(false);
			this.setState({
				type: type,
				storyModule: story,
				otherModules: otherModules,
				showStory: true,
				selectedStoryIndex: storyIndex
			});
		} else {
			for (var i = 0; i < data.contents.images.length; i++) {
				if (data.contents.images[i]) {
					let fileType = getFileType(data.contents.images[i].file_name);
					let vType = null;
					if (fileType === "Video") {
						vType = videoType(data.contents.images[i].file_name);
					}
					slickAssets.push({ fileType: fileType, videoType: vType, path: shared.dpath(this.props.screen.mode, data.contents.images[i].path, data.contents.images[i].file_name, this.props.screen.webkey) })
				}
			}
			//first image is thumbnail unless only one image
			if (slickAssets.length >= 2) {
				slickAssets = slickAssets.slice(1)
			}
			// this._donorGroupIndex = donorGroupIndex;
			this._selectDonorId = data.id;
			let mainimage = "img/ui/image_default.png";
			if (data.contents && data.contents.images[1]) {
				mainimage = shared.dpath(this.props.screen.mode, data.contents.images[1].path, data.contents.images[1].file_name, this.props.screen.webkey);
			} else if (data.contents && data.contents.images[0]) {
				mainimage = shared.dpath(this.props.screen.mode, data.contents.images[0].path, data.contents.images[0].file_name, this.props.screen.webkey);
			}
			let showQuotes = false;
			if (_.has(data, 'contents.custom_fields.show_quotes.val')) {
				showQuotes = data.contents.custom_fields.show_quotes.val
			}
			this.props.toggleShowClock(false);
			let textOps = _.get(data.contents.custom_fields, 'line_1.val.ops', {});
			console.log(data);
			let converter = new QuillDeltaToHtmlConverter(textOps, {}); 
			let richText = converter.convert();
			this.setState({
				showStory: true,
				selectedStoryIndex: storyIndex,
				story: {
					type: type,
					contextualheader: "",
					headline: data.name,
					subtitle: _.has(data, 'contents.texts[0].text') ? data.contents.texts[0].text : "",
					body: richText,
					quote: _.has(data, 'contents.texts[2].text') ? data.contents.texts[2].text : "",
					mainimage: mainimage,
					id: data.id ? data.id : "",
					slickAssets: slickAssets,
					showQuotes: showQuotes
				}
			});

		}

	}

	cycleStory = (direction) => {
		let newIndex = shared.loopIndex(this.state.selectedStoryIndex, 0, this.state.stories.length - 1, direction);
		let selectedStory = this.state.stories[newIndex];

		this.handleDonorClick(selectedStory, newIndex);
	}

	navarea = (width, height) => {
		return (
			<div style={{ position: 'absolute', width: width, height: height - (width / 2), bottom: 0, left: 0, backgroundColor: '#424958', zIndex: 99 }} />
		)
	}

	render() {
		// return (<span/>);
		let links = [];
		let renderedStories = this.renderStories();
		let viewConfig = {
			list_offset: this.props.screen.r16_9.left + this.props.screen.r16_9.p10 * 3,
			list_width: this.props.screen.r16_9.width - this.props.screen.r16_9.p10 * 3,
		}
		// _.map(this.state.donorsGrouped, (group) => {
		// 	links.push({ name: group.name, navroute: null })
		// })
		
		let folder = this.props.content.story_categories[Number(this.props.folder)];
		links = [{ name: folder.name, navroute: null }];

		let modalBorderV = .035 * this.props.screen.screenHeight;
		let modalBorderH = .02 * this.props.screen.r16_9.width;
		let navarea = this.navarea(this.props.screen.r16_9.width - (modalBorderH * 2), this.props.screen.screenHeight - (modalBorderV * 2))

		this._refCounter = 0;
		return (
			<div>
				<div style={{ position: 'absolute' }}>
					<div style={{ zIndex: 10, width: '100vw', height: '100vh' }}>
						<div style={{ position: 'absolute', left: this.props.screen.r16_9.left, top: this.props.screen.r16_9.p10 * 2 }}>

						</div>
						<div style={{ position: 'absolute', left: this.props.screen.r16_9.left, top: this.props.screen.r16_9.p10 * 2 }}>
							<LinkListChicago fontClass={this._fontClass} selectedLinkIndex={this.state.selectedLinkIndex} screen={this.props.screen} links={links} switchCategory={this.switchCategory} colorInactive={'#496778'} />
						</div>
						
						<div style={{ position: 'absolute', left: viewConfig.list_offset, backgroundColor: '#496778', width: viewConfig.list_width, height: this.props.screen.screenHeight, touchAction:"none" }}>
							<ReactIScroll ref={el => this.scrollRef[0] = el} iScroll={iScroll}
								options={{
									scrollX: false,
									scrollY: true,
									probeType: 2,
									disableTouch: false,
									disablePointer: false,
									disableMouse: false,
									momentum: true,
									deceleration: 0.01,
									tap: true,
									mouseWheel: true,
									useTransition: true
								}}
								onRefresh={this.initializeDonorRefs}
							>

								<div>
									{renderedStories}
									<div style={{ display: 'inline-block', width: '100%', height: this.props.screen.screenHeight * .15 }} />
								</div>
							</ReactIScroll>
						</div>

					</div>
				</div>
				<CSSTransitionGroup
					component='div'
					transitionName='example'
					transitionEnterTimeout={0}
					transitionLeaveTimeout={0}>
					<div key={this.state.showStory}>
						{this.state.showStory ?
							<div>
								<div style={{ position: 'fixed', pointerEvents: 'none', top: 0, left: this.props.screen.r16_9.left, width: this.props.screen.r16_9.width, height: this.props.screen.sv.height, backgroundColor: 'black', opacity: .5 }} />
								<div style={{ pointerEvents: 'none', position: 'absolute', left: modalBorderH + this.props.screen.r16_9.left, width: this.props.screen.r16_9.width - (modalBorderH * 2), height: this.props.screen.screenHeight - (modalBorderV * 2), top: modalBorderV, backgroundColor: 'white', zIndex: 100 }}>
									{navarea}
								</div>
							</div>
							:
							<span />
						}
					</div>
				</CSSTransitionGroup>
				<div style={{ zIndex: 9999, position: 'fixed', pointerEvents: 'none', top: 0, left: this.props.screen.r16_9.left, width: this.props.screen.r16_9.width, height: this.props.screen.sv.height }}>
					{/* Screen 2 Slides */}
					<CSSTransitionGroup
						component='div'
						transitionName='example'
						transitionEnterTimeout={0}
						transitionLeaveTimeout={0}>
						<div style={{ width: this.props.screen.screenWidth, height:this.props.screen.screenHeight }} key={this.state.story.id}>
							{this.state.showStory ?
								<div style={{ width: "100%", height:"100%" }}>
									{/* split this out to seperate transition that is ONLY based on showStory or not */}

									{
										this.state.type === "baby_announcement" ?
											// <span/>
											<StoryAnnouncement 
												screen={this.props.screen}
												story={this.state.storyModule}
												otherModules={this.state.otherModules}
												idle={this.state.idle}
												closeStory={this.closeStory}
												left={modalBorderH}
												top={modalBorderV}
												width={this.props.screen.r16_9.width - (modalBorderH * 2)}
												height={this.props.screen.screenHeight - (modalBorderV * 2)}
												cycleStory={this.cycleStory}
												modal={true} 
											/>
										:
											<StoryChicagoModal
												fontClass={this._fontClass}
												closeStory={this.closeStory}
												contextualheader={this.state.story.contextualheader}
												headline={this.state.story.headline}
												subtitle={this.state.story.subtitle}
												body={this.state.story.body}
												quote={this.state.story.quote}
												mainimage={this.state.story.mainimage}
												slickAssets={this.state.story.slickAssets}
												left={modalBorderH}
												top={modalBorderV}
												width={this.props.screen.r16_9.width - (modalBorderH * 2)}
												height={this.props.screen.screenHeight - (modalBorderV * 2)}
												zIndex={100}
												cycleStory={this.cycleStory}
												showQuotes={this.state.story.showQuotes}
												useWYSIWYG={true}
											/>
									}
								</div>
								:
								<span />}
						</div>
					</CSSTransitionGroup>
				</div>
			</div>
		)
	}




}

const mapStateToProps = (state) => {
	let folder = shared.parseStringParam(window.location.href, "id");
	return {
		module: state.content.dm_active[state.active_module],
		screen: state.screen,
		content: state.content,
		donors: state.donors,
		folder: folder
	};
};

export default connect(mapStateToProps, null)(StoriesFoldersChicago);



// WEBPACK FOOTER //
// ./src/Components/Theme/Chicago/StoriesFoldersChicago.js